
function boardColumnDialog () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/board-column/board-column-dialog.html?$$REVISION$$'
  }
}
export { boardColumnDialog }
